import React, {useEffect, useCallback, useRef, useState} from 'react';

import { currency } from '@helpers';
import useFeedback from '@hooks/useFeedback';

import Input from 'components/Input';
import Button from 'components/Button';
import Alert from 'components/Dialog/Alert';
import { Spinner } from 'styles/common';

import avatar from 'assets/images/avatar-blank.png';

import { EMOJI_LIST } from 'components/Feedback/List/Item';

import {
	FeedbackForm,
	Head,
	Title,
	EmojiList,
	EmojiPlace,
	Comment,
	Footer,
	CommentText,
	CommentBody,
	CommnetHeader,
} from './style';
import {fetchCompanyConfig} from "@api/company";

const Form = ({ calculateHeight = () => {}, goStatistic, invoiceId }) => {
	const alertRef = useRef();
	const [settings, setSettings] = useState(null);
	useEffect(() => {
		fetchCompanyConfig().then(r => setSettings(r))
	}, []);
	const {
		submitting,
		values,
		errors,
		onChangeComment,
		onSelectRate,
		onSubmit,
		hasRate,
	} = useFeedback(invoiceId);

	useEffect(() => {
		setTimeout(() => {
			calculateHeight();
		}, 200);
	}, []);

	useEffect(() => {
		setTimeout(() => {
			calculateHeight();
		}, 100);
	}, [values.feedbackItemViewModels]);

	const onSendRate = useCallback(
		async (e) => {
			e.preventDefault();

			const result = await onSubmit();

			if (result.success) {
				alertRef.current.show(result.message, 'tick');
				calculateHeight();
			} else if (result.message) {
				alertRef.current.show(result.message, 'alert');
			}
		},
		[onSubmit],
	);

	return (
		<>
			<Head>نظر خود را در مورد غذایی که سفارش داده‌اید ثبت کنید</Head>
			<FeedbackForm>
				<div style={{ maxHeight: "400px", overflow: "auto" }}>
					{(values.feedbackItemViewModels === null || !settings) ? (
						<Spinner $size='lg' $block $margin={70} />
					) : (
						<>
							{values.feedbackItemViewModels.map((item) => (
								<div key={item.invoiceItemId}>
									<Title>
										<h5>{item.foodItemName}</h5>
										{settings?.showPrice && <h6>قیمت غذا: {currency(item.invoiceItemPrice)}</h6>}
									</Title>

									<EmojiList>
										{Object.keys(EMOJI_LIST).map((key) => {
											const emoji = EMOJI_LIST[key];

											return (
												<EmojiPlace
													$checked={emoji.value === item.feedbackItemRate}
													$disabled={hasRate}
													key={emoji.value}
												>
													<button
														type='button'
														onClick={() =>
															onSelectRate(item.invoiceItemId, emoji.value)
														}
													>
														<img src={emoji.image} alt={emoji.title} />
													</button>
												</EmojiPlace>
											);
										})}
									</EmojiList>
								</div>
							))}
						</>
					)}
				</div>

				<Comment>
					{hasRate && values.feedbackComment && (
						<div>
							<CommentText>
								<CommentBody>{values.feedbackComment}</CommentBody>
								<CommnetHeader>
									<img src={avatar} alt='avatar' />
								</CommnetHeader>
							</CommentText>
						</div>
					)}

					{!hasRate && (
						<>
							<img src={avatar} alt='avatar' />
							<Input
								type='textarea'
								name='feedbackComment'
								onChange={(e) => onChangeComment(e.target.value)}
								error={errors.feedbackComment}
								value={values.feedbackComment}
								placeholder='ثبت توضیحات بیشتر ...'
							/>
						</>
					)}
				</Comment>

				<Footer>
					<Button
						type='button'
						className='list'
						outline
						color='grayLight'
						size='sm'
						onClick={goStatistic}
						onDisable={() => {
							alertRef.current.show(
								'برای مشاهده نظر همکاران ابتدا باید نظر خود را ثبت کنید',
								'alert',
							);
						}}
						disabled={values.feedbackItemViewModels === null || !hasRate}
					>
						مشاهده نظر همکاران
					</Button>

					{!hasRate && (
						<Button
							loading={submitting}
							type='submit'
							block
							onClick={onSendRate}
						>
							ثبت نظر
						</Button>
					)}
				</Footer>
				<Alert ref={alertRef} />
			</FeedbackForm>
		</>
	);
};

export default Form;
